$(document).ready(function () {
  Sceon.Lang.signup = {
    username_invalid: '',
    username_invalid_characters: '',
    username_exists: '',
    password_invalid: '',
    password2_invalid: '',
    email_invalid: '',
    email_exists: '',
    terms_required: '',
    form_errors: '',
    domain_blacklisted: '',
  };

  Sceon.Validator = {};

  Sceon.Validator.Configs = {
    username: {},
    password: {},
  };

  Sceon.Validator.Lang = {};

  Sceon.Validator.getErrorElement = function (el) {
    return $(el).closest('.input-wrapper').find('.error');
  };

  Sceon.Validator.setError = function (el, error_text) {
    $(Sceon.Validator.getErrorElement(el)).html(error_text);
    $(el).closest('.input-wrapper').addClass('invalid');
  };

  Sceon.Validator.removeError = function (el) {
    $(Sceon.Validator.getErrorElement(el)).html('');
    $(el).closest('.input-wrapper').removeClass('invalid');
  };

  Sceon.Validator.SignUp = function () {
    let $username = $('#username');
    let $email = $('#email');
    let $password = $('#password');
    let $confirm_password = $('#confirm_password');

    if (!$username.length) {
      return;
    }

    $username.blur(function () {
      Sceon.Validator.removeError($username);
      if (
        $username.val().length <
        (parseInt(Sceon.Validator.Configs.username.min) || 6)
      ) {
        Sceon.Validator.setError($username, Sceon.Lang.signup.username_invalid);
        return;
      }

      let regex = Sceon.Validator.Configs.username.pattern
        ? new RegExp(Sceon.Validator.Configs.username.pattern, 'i')
        : /^[-_a-z0-9]+$/i;

      if (!regex.test($username.val())) {
        Sceon.Validator.setError(
          $username,
          Sceon.Lang.signup.username_invalid_characters,
        );
        return;
      }

      $.ajax({
        url: '/private/check?username=' + $username.val(),
        method: 'GET',
        success: function (resp) {
          if (resp.status == 'found') {
            Sceon.Validator.setError(
              $username,
              Sceon.Lang.signup.username_exists,
            );
          } else if (resp.status == 'not found') {
            Sceon.Validator.removeError($username);
          }
        },
      });
    });

    $password.blur(function () {
      Sceon.Validator.removeError($password);

      if ($username.val() === $password.val()) {
        Sceon.Validator.setError(
          $password,
          Sceon.Lang.signup.username_equal_password,
        );
        return;
      }

      if (
        $password.val() <
          (parseInt(Sceon.Validator.Configs.password.min) || 8) ||
        $password.val() > (parseInt(Sceon.Validator.Configs.password.max) || 20)
      ) {
        Sceon.Validator.setError($password, Sceon.Lang.signup.password_invalid);
      } else {
        Sceon.Validator.removeError($password);
      }

      let regex = Sceon.Validator.Configs.password.pattern
        ? new RegExp(Sceon.Validator.Configs.password.pattern)
        : new Regex(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*\\-\\_\\?])(?=.{8,20})',
          );

      if (!regex.test($password.val())) {
        Sceon.Validator.setError(
          $password,
          Sceon.Lang.signup.password_invalid_characters,
        );
        return;
      }
    });

    $confirm_password.blur(function () {
      Sceon.Validator.removeError($confirm_password);
      $password.trigger('blur');

      if ($password.closest('.input-wrapper').hasClass('invalid')) {
        return;
      }

      if ($confirm_password.val() !== $password.val()) {
        Sceon.Validator.setError(
          $confirm_password,
          Sceon.Lang.signup.confirm_invalid,
        );
      } else {
        Sceon.Validator.removeError(
          $confirm_password,
          Sceon.Lang.signup.confirm_invalid,
        );
      }
    });

    $email.blur(function () {
      Sceon.Validator.removeError($email);

      let regex = new RegExp(
        '^(([^<>()\\[\\]\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
      );
      if (!$email.val().length || !regex.test($email.val())) {
        Sceon.Validator.setError($email, Sceon.Lang.signup.email_invalid);
        return;
      }

      $.ajax({
        url: '/private/check?email=' + $email.val(),
        method: 'GET',
        success: function (resp) {
          if (resp.status == 'not found') {
            Sceon.Validator.removeError($email);
          } else if (resp.status == 'found') {
            Sceon.Validator.setError($email, Sceon.Lang.signup.email_exists);
          } else if (resp.status == 'blacklisted') {
            Sceon.Validator.setError(
              $email,
              Sceon.Lang.signup.domain_blacklisted,
            );
          }
        },
      });
    });
  };

  Sceon.Validator.SignUp();
});
